// src/components/postanalysis components/tabs/PA_Glossary.js
import React from "react";

export default function Glossary({ filters, setFilters }) {
  return (
    <div className="p-4 space-y-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Glossary</h1>
        <p className="text-muted-foreground mt-2">
          ROI and Volume Uplift Calculation Explanation
        </p>
      </div>

      <div className="space-y-8">
        <div className="space-y-3">
          <h2 className="text-xl font-semibold">OFF Premise Calculations</h2>
          <div className="flex justify-center bg-gray-50 p-4 rounded-lg">
            <img 
              src="/Off_Trade_Explanation.png" 
              alt="OFF Premise Calculations" 
              className="max-w-full h-auto rounded-lg border border-gray-200 shadow-sm"
              style={{ maxHeight: "600px" }}
            />
          </div>
        </div>

        <div className="space-y-3">
          <h2 className="text-xl font-semibold">ON Premise Calculations</h2>
          <div className="flex justify-center bg-gray-50 p-4 rounded-lg">
            <img 
              src="/On_Trade_Explanation.png" 
              alt="ON Premise Calculations" 
              className="max-w-full h-auto rounded-lg border border-gray-200 shadow-sm"
              style={{ maxHeight: "600px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

